import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import { useLoading } from './Loading';
import { useTranslation } from './I18nContext';
import apiCall from 'shared/services/ApiAdapter';// ... rest of LoadingContext code ...// Manages student-related state and provides CRUD operations for students.
import { getCurrentUserId } from 'shared/utils/SessionDataUtils';
const StudentContext = createContext();

export const StudentProvider = ({ children }) => {
    const [students, setStudents] = useState([]);
    const { startLoading, stopLoading } = useLoading();
    const { t } = useTranslation();

    const fetchStudents = useCallback(async (useMockData, displayToast, targetUserId = null) => {
        const queryUserId = targetUserId || getCurrentUserId();
        try {
            const url = `/students?createdBy.equals=${queryUserId}`;
            const data = await apiCall(url, useMockData, 'GET', null, startLoading, stopLoading, displayToast);
            setStudents(data);
        } catch (error) {
            console.error("Failed to fetch students:", error);
            // Toast already handled by apiCall
        }
    }, [startLoading, stopLoading]);

    const addStudent = useCallback(async (newStudent, useMockData, displayToast) => {
        try {
            const addedStudent = await apiCall('/students', useMockData, 'POST', newStudent, startLoading, stopLoading, displayToast);
            setStudents(prev => [...prev, addedStudent]);
            displayToast(t('studentCreatedSuccessfully'), 'success');
            return addedStudent;
        } catch (error) {
            console.error("Failed to add student:", error);
            displayToast(t('failedToSaveStudent'), 'error');
            throw error;
        }
    }, [startLoading, stopLoading, t]);

    const updateStudent = useCallback(async (updatedStudent, useMockData, displayToast) => {
        try {
            const response = await apiCall(`/students/${updatedStudent.id}`, useMockData, 'PUT', updatedStudent, startLoading, stopLoading, displayToast);
            setStudents(prev => prev.map(s => (s.id === updatedStudent.id ? response : s)));
            displayToast(t('studentUpdatedSuccessfully'), 'success');
            return response;
        } catch (error) {
            console.error("Failed to update student:", error);
            displayToast(t('failedToSaveStudent'), 'error');
            throw error;
        }
    }, [startLoading, stopLoading, t]);

    const getStudentById = useCallback((id) => {
        return students.find(s => s.id === id);
    }, [students]);

    return (
        <StudentContext.Provider value={{ students, fetchStudents, addStudent, updateStudent, getStudentById }}>
            {children}
        </StudentContext.Provider>
    );
};

export const useStudents = () => {
    return useContext(StudentContext);
};
